import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/CourseDetails";
import ProductAndServices from "./pages/ProductAndServices";
import SummerCamps from "./pages/SummerCamps";
import WinterCamps from "./pages/WinterCamps";
import CampsRegistration from "./pages/CampsRegistration";
import Competitions from "./pages/Competitions";
import CompetitionRegistration from "./pages/CompetitionRegistration";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import SignUp from "./pages/SignUp";
import StudentRegistration from "./pages/StudentRegistration";
import { ProtectedRoute, SignupProfileRoute } from "./hooks/useAuth";
import Blog from "./pages/Blog";
import InstructorRegistration from "./pages/InstructorRegistration";
import StudentDashboard from "./pages/student/Dashboard";
import StudentCourses from "./pages/student/Courses";
import Settings from "./pages/student/Settings";
import Wishlist from "./pages/student/Wishlist";
import CourseOverview from "./pages/student/CourseOverview";
import RequestCourseDemo from "./pages/student/RequestCourseDemo";
import BuyCourse from "./pages/student/BuyCourse";
import SelectClassTime from "./pages/student/SelectClassTime";
import Checkout from "./pages/student/Checkout";
import Quiz from "./pages/student/Quiz";
import Certificates from "./pages/student/Certificates";
import Certificate from "./pages/Certificate";
import UpcomingSessions from "./pages/student/UpcomingSessions";
import ContinueLearning from "./pages/student/ContinueLearning";
import LecturePlayer from "./pages/student/LecturePlayer";
import InstructorDashboard from "./pages/instructor/Dashboard";
import EditProfile from "./pages/instructor/EditProfile";
import MyProfile from "./pages/instructor/MyProfile";
import MyCourses from "./pages/instructor/MyCourses";
import InstructorCourseDetails from "./pages/instructor/CourseDetails";
import InstructorQuiz from "./pages/instructor/InstructorQuiz";
import SetAvailability from "./pages/instructor/SetAvailability";
import ManageSessions from "./pages/instructor/ManageSessions";
import SessionDetails from "./pages/instructor/SessionDetails";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/productandservices" element={<ProductAndServices />} />
        <Route path="/courses/:courseId" element={<CourseDetails />} />
        <Route path="/competitions" element={<Competitions />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route
          path="/certificate/verify/:certificateId"
          element={<Certificate />}
        />

        <Route
          path="/competition/competition-registration"
          element={<CompetitionRegistration />}
        />
        <Route path="/camps/summer" element={<SummerCamps />} />
        <Route path="/camps/winter" element={<WinterCamps />} />
        <Route
          path="/camps/camps-registration"
          element={<CampsRegistration />}
        />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/signup/student-registration"
          element={
            <SignupProfileRoute role="student">
              <StudentRegistration />
            </SignupProfileRoute>
          }
        />

        <Route element={<ProtectedRoute role="student" />}>
          <Route path="/student" element={<StudentDashboard />} />
          <Route path="/student/courses" element={<StudentCourses />} />
          <Route path="/student/settings" element={<Settings />} />
          <Route path="/student/wishlist" element={<Wishlist />} />
          <Route
            path="/student/view-course/:courseId"
            element={<CourseOverview />}
          />
          <Route
            path="/student/request-course-demo/:courseId"
            element={<RequestCourseDemo />}
          />
          <Route path="/student/buy-course" element={<BuyCourse />} />
          <Route
            path="/student/select-class-time"
            element={<SelectClassTime />}
          />
          <Route path="/student/checkout" element={<Checkout />} />
          <Route path="/student/quiz" element={<Quiz />} />
          <Route path="/student/certificates" element={<Certificates />} />
          <Route
            path="/student/upcoming-sessions"
            element={<UpcomingSessions />}
          />
          <Route
            path="/student/lectures/:lectureId"
            element={<LecturePlayer />}
          />
          <Route
            path="/student/:sessionType/:courseId"
            element={<ContinueLearning />}
          />
        </Route>

        <Route
          path="/signup/instructor-registration"
          element={
            <SignupProfileRoute role="teacher">
              <InstructorRegistration />
            </SignupProfileRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<ProtectedRoute role="instructor" />}>
          <Route
            path="/instructor/dashboard"
            element={<InstructorDashboard />}
          />
          <Route path="/instructor/profile" element={<MyProfile />} />
          <Route
            path="/instructor/profile/edit-profile"
            element={<EditProfile />}
          />
          <Route path="/instructor/courses" element={<MyCourses />} />
          <Route
            path="/instructor/courses/:id"
            element={<InstructorCourseDetails />}
          />
          <Route
            path="/instructor/instructor-quiz"
            element={<InstructorQuiz />}
          />
          <Route
            path="/instructor/set-availability"
            element={<SetAvailability />}
          />
          <Route
            path="/instructor/manage-sessions"
            element={<ManageSessions />}
          />
          <Route
            path="/instructor/manage-sessions/:id"
            element={<SessionDetails />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
